<template>
  <v-btn
    ref="articleHeaderButton"
    class="d-flex align-center justify-center my-2 my-sm-3"
    :class="
      newArticleDetailsDisplay
        ? 'article-header-button-redesign mr-sm-4 px-3'
        : 'article-header-button mr-sm-6 py-3 px-6'
    "
    :outlined="outlined"
    :aria-label="ariaLabel"
    :color="color"
    elevation="0"
    @click="onClick"
  >
    <slot />
    <span
      :class="
        newArticleDetailsDisplay
          ? 'article-header-button-redesign__text'
          : 'article-header-button__text'
      "
    >
      {{ buttonText }}</span
    >
  </v-btn>
</template>

<script>
import mapFlags from "~/plugins/utilities/mapFlags";

export default {
  name: "ArticleHeaderButton",
  props: {
    buttonText: { type: String, default: "" },
    ariaLabel: { type: String, default: "" },
    color: { type: String, default: "primary" },
    outlined: { type: Boolean, default: true },
    emitOnClick: { type: String, required: true },
  },
  computed: {
    ...mapFlags(["newArticleDetailsDisplay"]),
  },
  methods: {
    onClick() {
      this.$emit(this.emitOnClick);
    },
  },
};
</script>

<style lang="scss" scoped>
.article-header-button {
  box-sizing: border-box;
  border-radius: 4px;
  height: 48px !important;
  width: 100%;

  &__text {
    font-size: 16px;
    line-height: 24px;
    font-weight: 600;
  }
}

.article-header-button-redesign {
  box-sizing: border-box;
  border-radius: 4px;
  padding-top: 6px !important;
  padding-bottom: 6px !important;

  &__text {
    font-size: 13px;
    line-height: 24px;
    font-weight: 500;
  }
}

@media only screen and (min-width: 600px) {
  .article-header-button {
    width: 190px !important;
  }
}

@media only screen and (max-width: 600px) {
  .article-header-button-redesign {
    width: 100% !important;
  }
}
</style>
